import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=ca8c775a&scoped=true&lang=html"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8c775a",
  null
  
)

export default component.exports